import React from 'react';
import { ParallaxProvider } from 'react-scroll-parallax';
import connectActionsAndReducers from '../../toolbox/connectActionsAndReducers';
import HeroBanner from '../../components/landing/HeroBanner';
import InfoSection from '../../components/landing/InfoSection';
import FeatureCarousel from '../../components/landing/FeatureCarousel';
import Statistics from '../../components/landing/Statistics';
import FindUs from '../../components/landing/FindUs';
import ContactUs from '../../components/landing/ContactUs';
import PublicTestimonialContainer from '../../containers/testimonial/PublicTestimonialContainer';
import HIPPA from '../../components/landing/HIPPA';

const LandingPageContainer = props => (
  <ParallaxProvider>
    <div>
      <HeroBanner
        onRequestDemo={props.actions.requestDemo}
      />
      <HIPPA />
      <InfoSection />
      <FeatureCarousel />
      <Statistics />
      <PublicTestimonialContainer
        showAll={false}
        testimonials={props.reducers.testimonial.testimonials}
        specialties={props.reducers.metadata.data.specialty}
        medicalGroups={props.reducers.metadata.data.medicalGroup}
        {...props}
      />
      <FindUs />
      <ContactUs />
    </div>
  </ParallaxProvider>
);

export default connectActionsAndReducers(LandingPageContainer);



// WEBPACK FOOTER //
// ./src/containers/landing/LandingPageContainer.js